import Navbar from "react-bootstrap/Navbar";
import { Container } from "react-bootstrap";
import { googleLogout } from '@react-oauth/google';

/**
 * Renders the navbar component with a sign-in button if a user is not authenticated
 */
export const PageLayout = (props) => {
    const handleLogout = () => {
        googleLogout();
        if (props.onLogout) {
            props.onLogout();
        } else {
            props.setProfile(null);
            props.setUser(null);
        }
    };

    return (
        <Container>
            {props.profile && (
                <Navbar expand="lg" bg="dark" variant="dark" className="custom-navbar">
                    <Container className="navbar-container">
                        <a className="navbar-brand custom-brand" href="/">
                            The Heist Portal
                        </a>
                        
                        <div className="user-profile-section">
                            <div className="user-info">
                                <img
                                    src={props.profile.picture}
                                    alt="user"
                                    className="user-avatar"
                                />
                                <span className="user-name">{props.profile.name}</span>
                            </div>
                            {props.isAdmin && (
                                <button
                                    className={`view-toggle-button${props.adminMode ? ' view-toggle-active' : ''}`}
                                    onClick={() => props.setAdminMode(!props.adminMode)}
                                >
                                    {props.adminMode ? 'Admin View' : 'User View'}
                                </button>
                            )}
                            <button
                                className="logout-button"
                                onClick={handleLogout}
                            >
                                Logout
                            </button>
                        </div>
                    </Container>
                </Navbar>
            )}
            {props.profile && <br />}
            {props.children}
        </Container>
    );
};